import { render, staticRenderFns } from "./ViewMemberDialog.vue?vue&type=template&id=1a039204&scoped=true"
import script from "./ViewMemberDialog.vue?vue&type=script&lang=js"
export * from "./ViewMemberDialog.vue?vue&type=script&lang=js"
import style0 from "./ViewMemberDialog.vue?vue&type=style&index=0&id=1a039204&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a039204",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Karl\\Code\\customs_clearance\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1a039204')) {
      api.createRecord('1a039204', component.options)
    } else {
      api.reload('1a039204', component.options)
    }
    module.hot.accept("./ViewMemberDialog.vue?vue&type=template&id=1a039204&scoped=true", function () {
      api.rerender('1a039204', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/company/components/ViewMemberDialog.vue"
export default component.exports